import React, { useState, useEffect, useCallback } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from '@/components/ui/sonner';

// Layout Components
import Header from '@/components/layout/Header';
import Footer from '@/components/layout/Footer';

// Section Components
import HeroSection from '@/components/sections/HeroSection';
import FeaturesStrip from '@/components/sections/FeaturesStrip';
import MarketTicker from '@/components/sections/MarketTicker';
import NewsSection from '@/components/sections/NewsSection';
import ServicesSection from '@/components/sections/ServicesSection';
import AboutSection from '@/components/sections/AboutSection';
import ContactSection from '@/components/sections/ContactSection';

// Data
import { getMockNews } from '@/data/mockNews';

const TradePulsePage = () => {
  const [language, setLanguage] = useState(() => {
    return localStorage.getItem('tradepulse-lang') || 'en';
  });
  const [news, setNews] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Initial load and language change handler
  useEffect(() => {
    const fetchNews = async () => {
      setIsLoading(true);
      // Simulate network delay
      await new Promise(resolve => setTimeout(resolve, 800));
      // Get mock news data
      const newsData = getMockNews(language);
      setNews(newsData);
      setIsLoading(false);
    };
    fetchNews();
  }, [language]);

  // Auto refresh every 30 minutes
  useEffect(() => {
    const interval = setInterval(() => {
      const fetchNews = async () => {
        setIsLoading(true);
        await new Promise(resolve => setTimeout(resolve, 800));
        const newsData = getMockNews(language);
        setNews(newsData);
        setIsLoading(false);
      };
      fetchNews();
    }, 30 * 60 * 1000);

    return () => clearInterval(interval);
  }, [language]);

  // Handle manual refresh
  const handleRefresh = useCallback(async () => {
    setIsLoading(true);
    await new Promise(resolve => setTimeout(resolve, 800));
    const newsData = getMockNews(language);
    setNews(newsData);
    setIsLoading(false);
  }, [language]);

  // Handle language change
  const handleLanguageChange = useCallback((newLang) => {
    setLanguage(newLang);
    localStorage.setItem('tradepulse-lang', newLang);
  }, []);

  return (
    <div className="min-h-screen bg-background">
      <Header 
        language={language}
        onLanguageChange={handleLanguageChange}
        onRefresh={handleRefresh}
        isLoading={isLoading}
      />
      
      <MarketTicker />
      
      <main>
        <HeroSection />
        <FeaturesStrip />
        <NewsSection news={news} isLoading={isLoading} />
        <ServicesSection />
        <AboutSection />
        <ContactSection />
      </main>
      
      <Footer />
      <Toaster position="top-right" />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<TradePulsePage />} />
        <Route path="*" element={<TradePulsePage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
